export type InfoTermsAction =
  | { type: 'SET_IS_FETCHING_TERMS_CONTENT' }
  | { type: 'SET_FETCH_TERMS_CONTENT_FAILED' }
  | { type: 'SET_TERMS_CONTENT', content: Julius.Website.TermsPageViewModel };

  export const setIsFetching = (): InfoTermsAction => ({
    type: 'SET_IS_FETCHING_TERMS_CONTENT',
  });

  export const setFetchFailed = (): InfoTermsAction => ({
    type: 'SET_FETCH_TERMS_CONTENT_FAILED',
  });

  export const setTermsContent = (content: Julius.Website.TermsPageViewModel): InfoTermsAction => ({
    content,
    type: 'SET_TERMS_CONTENT',
  });


// WEBPACK FOOTER //
// ./src/pages/InfoTermsPage/Redux/actions.tsx